import { TableFooter } from '@westhetics/ui'
import type { ReactNode } from 'react'
import type { ListMeta } from '@/lib/api'

/**
 * Rodapé de lista: a contagem ("1–25 de 331"), a explicação do critério e a paginação em texto.
 * Sem números de página: anterior e próxima bastam numa lista de trabalho.
 */
export function ListFooter({
  meta,
  noun,
  note,
  onPage,
}: {
  meta: ListMeta
  /** Singular e plural do que a lista conta: `['procedimento', 'procedimentos']`. */
  noun: [string, string]
  /** A camada que sustenta: critério de ordem, o que a busca cobre. */
  note?: ReactNode
  onPage: (page: number) => void
}) {
  const first = meta.total === 0 ? 0 : (meta.page - 1) * meta.perPage + 1
  const last = Math.min(meta.page * meta.perPage, meta.total)
  const count =
    meta.totalPages > 1
      ? `${first}–${last} de ${meta.total} ${noun[1]}`
      : `${meta.total} ${meta.total === 1 ? noun[0] : noun[1]}`
  return (
    <TableFooter>
      <span>
        {count}
        {note ? <> · {note}</> : null}
      </span>
      {meta.totalPages > 1 ? (
        <span className="flex items-center gap-4">
          <button
            type="button"
            disabled={meta.page <= 1}
            onClick={() => onPage(meta.page - 1)}
            className="hover:text-ink disabled:text-label-soft cursor-pointer disabled:cursor-default"
          >
            anterior
          </button>
          <button
            type="button"
            disabled={meta.page >= meta.totalPages}
            onClick={() => onPage(meta.page + 1)}
            className="hover:text-ink disabled:text-label-soft cursor-pointer disabled:cursor-default"
          >
            próxima
          </button>
        </span>
      ) : null}
    </TableFooter>
  )
}
